<!-- ============================================================================= -->
<!-- Ella Custom JS - Customize The Style For Layout -->
<!-- ============================================================================= -->

<!-- ============================================================================= -->
<!-- IMPORTANT DISCLAIMER -->
<!-- Please use only JS to style the layout. -->
<!-- ============================================================================= -->

const targetNode = document.body; // Of specifieker als je weet waar de prijzen staan

const config = { childList: true, subtree: true };

const callback = function(mutationsList, observer) {
  const moneySpans = document.querySelectorAll('span.money');
  moneySpans.forEach(span => {
    if (span.textContent.includes(" د.إ")) {
      span.textContent = span.textContent.replace(" د.إ", "");
    }
  });
};

// Start observer
const observer = new MutationObserver(callback);
observer.observe(targetNode, config);

// Optional: stop observer na een tijdje als je wilt
setTimeout(() => observer.disconnect(), 10000); // Na 10 seconden stoppen
